import React from 'react';
import Modal from '.';
import styles from './styles.scoped.css';
import PropTypes from 'prop-types';
import LoadingBars from '../LoadingBars';

ModalLoading.propTypes = {
  onDismiss: PropTypes.func,
  visible: PropTypes.bool.isRequired,
};

function ModalLoading({ visible, onDismiss }) {
  return (
    <Modal className={styles.modal} onClose={onDismiss} open={visible}>
      <div className={styles['loading-container']}>
        <LoadingBars size={4} />
      </div>
    </Modal>
  );
}

export default ModalLoading;
